<template>
  <div class="question-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="expandText">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="名称" prop="name">
                  <Input v-model="filterModel.name" placeholder="输入名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="标题" prop="title">
                  <Input v-model="filterModel.title" placeholder="输入标题" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="类别" prop="type" style="width: 100%">
                  <Select v-model="filterModel.type" filterable>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.appraisalQuestionType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="必填" prop="isRequired">
                  <RadioGroup v-model="filterModel.isRequired" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="true">是</Radio>
                    <Radio :label="false">否</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/guarantor-appraisal/new-question" icon="md-add">新增题目</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
    <Modal v-model="showDetailModal" title="详情" @on-cancel="closeDetailModal">
      <table class="detail-table" v-if="currentModel&&currentModel.name">
        <tr>
          <th>名称</th>
          <td>{{ currentModel.name }}</td>
        </tr>
        <tr>
          <th>标题</th>
          <td>{{ currentModel.title }}</td>
        </tr>
        <tr>
          <th>说明信息</th>
          <td>{{ currentModel.description }}</td>
        </tr>
        <tr>
          <th>类型</th>
          <td>{{ this.$common.appraisalQuestionType[currentModel.type.toString()] }}</td>
        </tr>
        <tr v-if="currentModel.type === 6">
          <th>选项</th>
          <td>
            <ul>
              <li v-for="(opt,optIdx) in getOptions(currentModel.extInfo)" :key="optIdx">
                {{ opt.value }}: {{ opt.label }}
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>默认值</th>
          <td>{{ currentModel.defaultValue }}</td>
        </tr>
        <tr>
          <th>是否必填</th>
          <td>{{ currentModel.isRequired }}</td>
        </tr>
        <tr>
          <th>评分表达式</th>
          <td>{{ currentModel.scoreFormula }}</td>
        </tr>
        <tr>
          <th>是否需要补充详情</th>
          <td>{{ currentModel.needDetail }}</td>
        </tr>
        <tr>
          <th>创建时间</th>
          <td>{{ $moment(currentModel.createTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'question-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '标题',
          key: 'title',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '类型',
          key: 'type',
          sortKey: 'type',
          resizable: true,
          width: 200,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.appraisalQuestionType[params.row.type.toString()])
          }
        },
        {
          title: '必填',
          key: 'isRequired',
          sortKey: 'isRequired',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, params.row.isRequired)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      this.currentModel = params.row
                      this.showDetailModal = true
                    }
                  }
                }, null)
              ]),
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push('/guarantor-appraisal/edit-question/' + params.row.tid)
                    }
                  }
                }, null),
              ]) : null,
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.tid
                      this.deleteItem(tId)
                    }
                  }
                }, null)
              ]) : null
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        title: null,
        type: null,
        isRequired: null,
        sortBy: 'tid',
        ascending: false
      },
      currentModel: null,
      showDetailModal: false
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    expandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏' : '展开') + '筛选条件'
    }
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getOptions (extInfo) {
      return JSON.parse(extInfo)
    },
    closeDetailModal () {
      this.currentModel = null
      this.showDetailModal = false
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Appraisal.listQuestion(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteItem (tId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该题目么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Appraisal.deleteAppraisalQuestion(tId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.tid === tId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
